import styled from "styled-components";
import { Paper, Box } from "@mui/material";
import theme from "../../../../styles/theme";

export const CardRoot = styled(Paper)`
  border: 1px solid #dbeafe;
  background: #f8fbff;
  border-radius: 12px !important;
  padding: 15px;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const LeftBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const IconTile = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #1264C7;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TitlePrice = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const PriceRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 4px;
  @media ${theme.devices.tablet} {
    flex-direction: column;
  }
`;

export const RightBlock = styled.div`
  display: flex;
  align-items: center;
`;

export const InfoBar = styled(Box)`
  margin-top: 14px;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid #dbeafe;
  background: #eef5ff;
  display: flex;
  align-items: center;
`;
